import type { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

type Props = PropsWithChildren<{ className?: string }>;

export const DefaultPage = (props: Props) => (
  <div
    className={cn(
      'box-border flex size-full flex-col items-center overflow-auto bg-[#fafafa] px-4 py-8 [scrollbar-gutter:stable] sm:px-8 md:px-12 lg:px-20',
      props.className
    )}
  >
    {props.children}
  </div>
);
